export default "__VITE_ASSET__Nm_o1we8__"